import { gql } from '@apollo/client';

export default gql`
  mutation updateSyncPageData($affectedResults: String!, $overrideLabels: Boolean) {
    updateSyncPageData(affectedResults: $affectedResults, overrideLabels: $overrideLabels)
  }
`;
